<div class="modal-header">
  <h4 class="modal-title">Request Payment</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <p>
    <ng-container *ngIf="amount === null || amount === undefined">
      <b>Full Payment ({{ orgConfig.getCurrencySymbol() }}{{ booking.amount_due }})</b>
    </ng-container>
    <ng-container *ngIf="amount !== null && amount !== undefined">
      <b>Partial Payment ({{ orgConfig.getCurrencySymbol() }}{{ amount }})</b>
    </ng-container>
  </p>

  <form (ngSubmit)="onSubmit()" #form="ngForm">

    <div class="form-group">
      <label for="recipient-select">Recipient</label>
      <select id="recipient-select" name="recipient_option"
              class="custom-select"
              [(ngModel)]="recipientOption">
        <option [value]="RecipientOption.bookingCustomer">
          Booking Customer Email: {{ booking.booked_by_email }}
        </option>
        <option [value]="RecipientOption.manual">
          Other Email Address
        </option>
        <option [value]="RecipientOption.noEmail">
          Don't Send an Email
        </option>
      </select>
      <small class="form-text text-muted"
             *ngIf="recipientOption === RecipientOption.noEmail">
        No email will be sent. After creating the request, use the Copy Link
        button on the pending requested payment to share the payment link
        yourself.
      </small>
    </div>

    <div class="form-group" *ngIf="recipientOption === RecipientOption.manual">
      <label for="manual-email">Email Address</label>
      <input id="manual-email" name="manual_email" type="email" required
             class="form-control"
             [(ngModel)]="manualEmail">
    </div>

    <div class="form-group">
      <label for="custom-note">Custom Note (optional)</label>
      <app-markdown-editor
        [id]="'requestPaymentCustomNote'"
        [(content)]="customNote"
        [shortEditor]="true"></app-markdown-editor>

      <button type="button"
              class="btn btn-outline-primary btn-sm mt-2"
              *ngIf="recipientOption !== RecipientOption.noEmail"
              (click)="openEmailPreview()">
        Preview Email
      </button>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="modal-footer mt-3 px-0 pb-0">
      <button type="button" class="btn btn-secondary"
              [disabled]="loading"
              (click)="activeModal.dismiss()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary"
              [disabled]="loading || !form.valid"
              [class.disabled]="loading || !form.valid">
        <ng-container *ngIf="recipientOption === RecipientOption.noEmail">
          {{ loading ? 'Creating...' : 'Create Payment Request' }}
        </ng-container>
        <ng-container *ngIf="recipientOption !== RecipientOption.noEmail">
          {{ loading ? 'Sending...' : 'Send Payment Request' }}
        </ng-container>
      </button>
    </div>
  </form>

</div>
